module.exports = __webpack_public_path__ + "img/help_other_y@3x.dd645083.png";